import { render, staticRenderFns } from "./VCheckbox.vue?vue&type=template&id=f61df01a&scoped=true&functional=true"
import script from "./VCheckbox.vue?vue&type=script&lang=js"
export * from "./VCheckbox.vue?vue&type=script&lang=js"
import style0 from "./VCheckbox.vue?vue&type=style&index=0&id=f61df01a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "f61df01a",
  null
  
)

export default component.exports